import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import PortalHouseAccounts from "./houseAccounts/PortalHouseAccounts";
import PortalCredit from "./credit/PortalCredit";
import PortalItemSales from "./itemSales/PortalItemSales";
import "./billingTabs.scss";

type TabNavigationType = {
  title: string;
  key: string;
};

export default function BillingTabs(): JSX.Element {
  const { t } = useTranslation();

  const customerTabInfo = generateCustomerTabs(t);
  const [activeTab, setActiveTab] = useState("house-accounts"); // default tab key

  return (
    <>
      <div className="portal-billing-navigation-container">
        <ul className="portal-billing-navigation-container_list">
          {customerTabInfo.map(tab => (
            <li
              key={tab.key}
              className={`portal-billing-navigation-container_li ${
                activeTab === tab.key ? "portal-billing-navigation-container_li_active" : ""
              }`}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.title}
            </li>
          ))}
        </ul>
      </div>

      <div className="tab-content">{displayCustomerPage(activeTab)}</div>
    </>
  );
}

const generateCustomerTabs = (t: any): TabNavigationType[] => [
  {
    title: t("House Account"),
    key: "house-accounts",
  },
  {
    title: t("Credit Book"),
    key: "credit",
  },
  {
    title: t("Order History"),
    key: "order-history",
  },
];

const displayCustomerPage = (tabKey: string): JSX.Element => {
  switch (tabKey) {
    case "house-accounts":
      return <PortalHouseAccounts />;
    case "credit":
      return <PortalCredit />;
    case "order-history":
      return <PortalItemSales />;
    default:
      return <div>Select a tab</div>;
  }
};
